import React from 'react';
import { viewProof, downloadProof } from '../utils/attachments';

const Attachments = ({ attachments }) => {
  if (!attachments || attachments.length === 0) {
    return <span style={{ color: 'var(--gray-400)' }}>No attachment</span>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      {attachments.map((a) => (
        <div key={a._id} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.875rem' }}>
          <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={a.originalName}>
            📎 {a.originalName}
          </span>
          <button type="button" className="btn btn-outline btn-sm" onClick={() => viewProof(a)}>View</button>
          <button type="button" className="btn btn-outline btn-sm" onClick={() => downloadProof(a)}>Download</button>
        </div>
      ))}
    </div>
  );
};

export default Attachments;
